/* This example requires Tailwind CSS v2.0+ */
import { Popover, Transition } from "@headlessui/react";
import { CodeIcon, CollectionIcon, LightningBoltIcon, MenuIcon, SupportIcon, UserGroupIcon, XIcon, InformationCircleIcon } from "@heroicons/react/outline";
import { ChevronDownIcon } from "@heroicons/react/solid";
import React, { Fragment } from "react";
import FullLogo from "./../images/logo-full-light.png";

const features = [
  {
    name: "Marketing Automation",
    description: "Automate cross-channel campaigns based on your customer’s persona and past behaviour.",
    href: "/features/automation",
    icon: LightningBoltIcon,
  },
  {
    name: "Customer Segmentation",
    description: "Engage with your customers based on their profile and behaviour.",
    href: "/features/segments",
    icon: UserGroupIcon,
  },
  {
    name: "Forms & Popups",
    description: "Collect data from abandoning visitors using popups, flyouts and inline forms.",
    href: "/features/forms-popups",
    icon: CollectionIcon,
  },
  // {
  //   name: "Actionable Analytics",
  //   description: "Your customers' data will be safe and secure.",
  //   href: "/features/forms-popups",
  //   icon: ChartBarIcon,
  // },
];
const resources = [
  // {
  //   name: "Blogs",
  //   description:
  //     "Get all of your questions answered in our forums or contact support.",
  //   href: "https://blogs.growlytics.in",
  //   icon: SpeakerphoneIcon,
  // },
  {
    name: "Blog",
    description: "All you need to know about marketing automation, customer engagement and Growlytics Platform.",
    href: "https://growlytics-blogs.webflow.io",
    icon: InformationCircleIcon,
  },
  {
    name: "Help Center",
    description: "Get all of your questions answered in our forums or contact support.",
    href: "http://help.growlytics.in",
    icon: SupportIcon,
  },
  {
    name: "Developer Docs",
    description: "Learn how to maximize our platform to get the most out of it.",
    href: "https://docs.growlytics.in",
    icon: CodeIcon,
  },
];
const recentPosts = [
  { id: 1, name: "Boost your conversion rate", href: "#" },
  {
    id: 2,
    name: "How to use search engine optimization to drive traffic to your site",
    href: "#",
  },
  { id: 3, name: "Improve your customer experience", href: "#" },
];

const mobileOtherPages = [
  {
    name: "Customers",
    href: "https://growlytics.in/customers",
  },
  {
    name: "Blog",
    href: "https://growlytics-blogs.webflow.io",
  },
  {
    name: "Help Center",
    href: "http://help.growlytics.in",
  },
  {
    name: "Developer Docs",
    href: "https://docs.growlytics.in",
  },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function NavBar(props) {
  return (
    <Popover className="relative bg-white" style={{ zIndex: 9999, backgroundColor: props.bg ? props.bg : "white" }}>
      {({ open }) => (
        <div>
          <div className="max-w-7xl mx-auto px-4 sm:px-6">
            <div className="flex justify-between items-center py-6 md:justify-start md:space-x-10">
              <div className="flex justify-start lg:w-0 lg:flex-1">
                <a href="/">
                  {/* <span className="text-base text-3xl font-bold text-primary-900 hover:text-primary-800">
                    Growlytics
                  </span> */}
                  <img className="w-40 h-auto" src={FullLogo} alt="Growlytics Logo" />
                </a>
              </div>
              <div className="-mr-2 -my-2 md:hidden justify-end md:flex-1 lg:w-0">
                <Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-600">
                  <span className="sr-only">Open menu</span>
                  <MenuIcon className="h-6 w-6" aria-hidden="true" />
                </Popover.Button>
              </div>
              <Popover.Group as="nav" className="hidden md:flex space-x-10 justify-end md:flex-1 lg:w-0">
                {/* <a href="/why-growlytics" className="text-base font-medium text-gray-500 hover:text-gray-900">
                  Why Growlytics?
                </a> */}
                <Popover className="relative">
                  {({ open }) => (
                    <>
                      <Popover.Button className={classNames(open ? "text-gray-900" : "text-gray-600", "group  rounded-md inline-flex items-center text-base font-medium hover:text-gray-900 focus:outline-none")}>
                        <span>Features</span>
                        <ChevronDownIcon className={classNames(open ? "text-gray-600" : "text-gray-600", "ml-0 pt-0.5 h-5 w-5 group-hover:text-gray-500")} aria-hidden="true" />
                      </Popover.Button>

                      <Transition show={open} as={Fragment} enter="transition ease-out duration-200" enterFrom="opacity-0 translate-y-1" enterTo="opacity-100 translate-y-0" leave="transition ease-in duration-150" leaveFrom="opacity-100 translate-y-0" leaveTo="opacity-0 translate-y-1">
                        <Popover.Panel static className="absolute z-10 -ml-4 mt-3 transform px-2 w-screen max-w-md sm:px-0 lg:ml-0 lg:left-1/2 lg:-translate-x-1/2">
                          <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden">
                            <div className="relative grid gap-6 bg-white px-5 py-6 sm:gap-8 sm:p-8">
                              {features.map((item) => (
                                <a key={item.name} href={item.href} className="-m-3 p-3 flex items-start rounded-lg hover:bg-gray-50">
                                  <item.icon className="flex-shrink-0 h-6 w-6 text-primary-600" aria-hidden="true" />
                                  <div className="ml-4">
                                    <p className="text-base font-medium text-gray-900">{item.name}</p>
                                    <p className="mt-1 text-sm text-gray-500">{item.description}</p>
                                  </div>
                                </a>
                              ))}
                            </div>
                          </div>
                        </Popover.Panel>
                      </Transition>
                    </>
                  )}
                </Popover>

                {/* <a href="/channels" className="text-base font-medium text-gray-500 hover:text-gray-900">
                  Channels
                </a> */}

                <a href="/customers" className="text-base font-medium text-gray-600 hover:text-gray-900">
                  Customers
                </a>

                <Popover className="relative">
                  {({ open }) => (
                    <>
                      <Popover.Button className={classNames(open ? "text-gray-900" : "text-gray-600", "group white rounded-md inline-flex items-center text-base font-medium hover:text-gray-900 focus:outline-none")}>
                        <span>Resources</span>
                        <ChevronDownIcon className={classNames(open ? "text-gray-600" : "text-gray-600", "ml-0 pt-0.5 h-5 w-5 group-hover:text-gray-500")} aria-hidden="true" />
                      </Popover.Button>

                      <Transition show={open} as={Fragment} enter="transition ease-out duration-200" enterFrom="opacity-0 translate-y-1" enterTo="opacity-100 translate-y-0" leave="transition ease-in duration-150" leaveFrom="opacity-100 translate-y-0" leaveTo="opacity-0 translate-y-1">
                        <Popover.Panel static className="absolute z-10 left-1/2 transform -translate-x-1/2 mt-3 px-2 w-screen max-w-md sm:px-0">
                          <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden">
                            <div className="relative grid gap-6 bg-white px-5 py-6 sm:gap-8 sm:p-8">
                              {resources.map((item) => (
                                <a key={item.name} href={item.href} className="-m-3 p-3 flex items-start rounded-lg hover:bg-gray-50">
                                  <item.icon className="flex-shrink-0 h-6 w-6 text-primary-600" aria-hidden="true" />
                                  <div className="ml-4">
                                    <p className="text-base font-medium text-gray-900">{item.name}</p>
                                    <p className="mt-1 text-sm text-gray-500">{item.description}</p>
                                  </div>
                                </a>
                              ))}
                            </div>
                            <div className="hidden px-5 py-5 bg-gray-50 sm:px-8 sm:py-8">
                              <div>
                                <h3 className="text-sm tracking-wide font-medium text-gray-500 uppercase">Recent Posts</h3>
                                <ul className="mt-4 space-y-4">
                                  {recentPosts.map((post) => (
                                    <li key={post.id} className="text-base truncate">
                                      <a href={post.href} className="font-medium text-gray-900 hover:text-gray-700">
                                        {post.name}
                                      </a>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                              <div className="mt-5 text-sm">
                                <a href="#" className="font-medium text-primary-600 hover:text-primary-600">
                                  {" "}
                                  View all posts <span aria-hidden="true">&rarr;</span>
                                </a>
                              </div>
                            </div>
                          </div>
                        </Popover.Panel>
                      </Transition>
                    </>
                  )}
                </Popover>
              </Popover.Group>
              <div className="hidden md:flex items-center justify-end md:flex-1 lg:w-0">
                <a href="/get-demo" className="whitespace-nowrap inline-flex items-center justify-center px-2 py-1 rounded-md shadow-sm text-base font-medium text-primary border border-primary-700 hover:bg-primary-600 hover:text-white">
                  Request Demo
                </a>
                <a href="https://app.growlytics.in/register" className="ml-4 whitespace-nowrap inline-flex items-center justify-center px-3 py-1 rounded-md text-base bg-primary-600 text-white">
                  Register
                </a>
                <a href="https://app.growlytics.in/login" className="ml-4 whitespace-nowrap text-base font-medium text-black">
                  Sign in
                </a>
              </div>
            </div>
          </div>

          <Transition show={open} as={Fragment} enter="duration-200 ease-out" enterFrom="opacity-0 scale-95" enterTo="opacity-100 scale-100" leave="duration-100 ease-in" leaveFrom="opacity-100 scale-100" leaveTo="opacity-0 scale-95">
            <Popover.Panel focus static className="absolute top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden">
              <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50">
                <div className="pt-5 pb-6 px-5">
                  <div className="flex items-center justify-between">
                    <div>
                      {/* <span className="text-base text-2xl font-bold text-primary-900 hover:text-primary-800">
                        Growlytics
                      </span> */}
                      <img className="h-8 w-auto" src={FullLogo} alt="Growlytics" />
                    </div>
                    <div className="-mr-2">
                      <Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-600">
                        <span className="sr-only">Close menu</span>
                        <XIcon className="h-6 w-6" aria-hidden="true" />
                      </Popover.Button>
                    </div>
                  </div>
                  <div className="mt-6">
                    <nav className="grid gap-y-8">
                      {features.map((item) => (
                        <a key={item.name} href={item.href} className="-m-3 p-3 flex items-center rounded-md hover:bg-gray-50">
                          <item.icon className="flex-shrink-0 h-6 w-6 text-primary-600" aria-hidden="true" />
                          <span className="ml-3 text-base font-medium text-gray-900">{item.name}</span>
                        </a>
                      ))}
                      {/* <a
                        href="/channels"
                        className="-m-3 p-3 flex items-center rounded-md hover:bg-gray-50"
                      >
                        <LightBulbIcon
                          className="flex-shrink-0 h-6 w-6 text-primary-600"
                          aria-hidden="true"
                        />
                        <span className="ml-3 text-base font-medium text-gray-900">
                          Marketing Channels
                        </span>
                      </a> */}
                    </nav>
                  </div>
                </div>
                <div className="py-6 px-5 space-y-6">
                  <div className="grid grid-cols-2 gap-y-4 gap-x-8">
                    {/* <a
                      href="/why-growlytics"
                      className="text-base font-medium text-gray-900 hover:text-gray-700"
                    >
                      Why Growlytics?
                    </a> */}
                    {mobileOtherPages.map((item) => (
                      <a key={item.name} href={item.href} className="text-base font-medium text-gray-900 hover:text-gray-700">
                        {item.name}
                      </a>
                    ))}
                  </div>
                  <div>
                    <a href="/get-demo" className="mb-4 w-full flex items-center justify-center px-4 py-2 border border-primary-600 rounded-md shadow-sm text-base font-medium text-primary-600">
                      Request Demo
                    </a>
                    <a href="https://app.growlytics.in/register" className="w-full flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-primary-600 hover:bg-primary-600">
                      Start Free Trial
                    </a>
                    <p className="mt-6 text-center text-base font-medium text-gray-500">
                      Existing customer?{" "}
                      <a href="https://app.growlytics.in/login" className="text-primary-600 hover:text-primary-600">
                        Sign in
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </Popover.Panel>
          </Transition>
        </div>
      )}
    </Popover>
  );
}
